/* Custom Video Player - Simple accessible Play/Pause button */
class CustomVideo extends HTMLElement {
  connectedCallback() {
    this.playLabel = this.getAttribute('label-play') || 'Play';
    this.pauseLabel = this.getAttribute('label-pause') || 'Pause';
    this.video = this.querySelector('video');
    this.button = this.querySelector('.custom-video__button');

    if (!this.video || !this.button) return;

    this.button.setAttribute('aria-label', this.playLabel);
    this.button.addEventListener('click', () => this.toggle());
    this.video.addEventListener('play', () => this.update(true));
    this.video.addEventListener('pause', () => this.update(false));
  }

  toggle() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  update(isPlaying) {
    this.button.classList.toggle('is-playing', isPlaying);
    this.button.setAttribute('aria-label', isPlaying ? this.pauseLabel : this.playLabel);
  }
}

customElements.define('custom-video', CustomVideo);


/* Custom Modal Drawers */
document.addEventListener('click', (event) => {
  const openModalDrawer = event.target.closest('.js-open-modal-drawer');
  const closeModalDrawer = event.target.closest('.js-close-modal-drawer');
  if (openModalDrawer) {
    const target = openModalDrawer.dataset.target;
    const drawer = document.querySelector(`.js-modal-drawer[data-drawer="${target}"]`);
    drawer.showModal();
  }
  if (closeModalDrawer) {
    const drawer = closeModalDrawer.closest('.js-modal-drawer');
    drawer.close();
  }
});


/* Product Card Add To Cart */
/* Made to work on recommended products section and complimentary products snippet */
const productFormSelector = 'form[id^="form_add-"]';
const productCardButtonSelector = '.product-card__add-to-cart';
const complementaryRecommendationsSelector = 'product-recommendations[data-intent="complementary"]';

function initAjaxProductCardForms(container = document) {
  if (
    !window.theme
    || !theme.AjaxProduct
    || theme.settings?.cartType !== 'drawer'
    || !container
    || typeof container.querySelectorAll !== 'function'
  ) {
    return;
  }

  container
    .querySelectorAll(productFormSelector)
    .forEach((form) => {
      if (!(form instanceof HTMLFormElement) || !form.querySelector(productCardButtonSelector)) {
        return;
      }

      if (form.dataset.ajaxBound === 'true') {
        return;
      }

      form.dataset.ajaxBound = 'true';
      new theme.AjaxProduct(form, productCardButtonSelector);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initAjaxProductCardForms();
});

document.addEventListener('shopify:section:load', (event) => {
  initAjaxProductCardForms(event.target);
});

document.addEventListener('recommendations:loaded', (event) => {
  initAjaxProductCardForms(event.detail?.section || document);
});

async function submitProductCardViaAjax(form) {
  const addToCartBtn = form.querySelector(productCardButtonSelector);
  if (addToCartBtn) {
    addToCartBtn.classList.add('btn--loading');
  }

  try {
    const data = new URLSearchParams(new FormData(form)).toString();
    const response = await fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    const product = await response.json();

    if (!response.ok || product.status === 422) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: product.description || 'Unable to add this item to your cart.',
        },
      }));
      return;
    }

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product,
        addToCartBtn,
      },
    }));
  } catch (error) {
    console.error('Product card add-to-cart failed', error);
  } finally {
    if (addToCartBtn) {
      addToCartBtn.classList.remove('btn--loading');
    }
  }
}

document.addEventListener('submit', async (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  if (!form.matches(productFormSelector) || !form.closest(complementaryRecommendationsSelector)) {
    return;
  }

  if (!window.theme || theme.settings?.cartType !== 'drawer') {
    return;
  }

  // If AjaxProduct is already bound, let the theme handler run.
  if (form.dataset.ajaxBound === 'true') {
    return;
  }

  event.preventDefault();
  await submitProductCardViaAjax(form);
});
